import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { UserDrinksService } from 'src/app/services/user-drinks.service';

@Component({
  selector: 'app-weekly-report-chart-units',
  templateUrl: './weekly-report-chart-units.component.html',
  styleUrls: ['./weekly-report-chart-units.component.scss']
})
export class WeeklyReportChartUnitsComponent {
  @Input() weeksData:any;

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    
    labels: [
    ],
    datasets: [
      {
        data: [  ],
        label: 'Units Consumed',
        fill: true,
        tension: 0.5,
        borderColor: '#01E5BE',
        borderWidth:2,
        backgroundColor: '#01E5BE',
        pointBackgroundColor:'#01E5BE',
        pointBorderColor:'#ffffff',
      }
    ]
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    plugins:{
      legend:{
        position:'bottom'
      }
    },
    scales:{
      y:{
        type: 'linear',
        display: true,
        position: 'left',
        suggestedMax: 14,
        suggestedMin: 0,
        beginAtZero:true,
        title: {
          display: true,
          text: "UNITS CONSUMED",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      },
      x:{
        display: true,
        title: {
          display: true,
          text: "WEEK NUMBER",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      }
    },
  };
  public lineChartLegend = false;


  constructor(private userDrinkService:UserDrinksService) {}

  ngOnInit(): void {
    this.setChartData();

  }

  setChartData() {
    
    this.lineChartData.datasets[0].data = [];
    this.lineChartData.labels = [];
   
    // setup chart data
    this.weeksData.slice().reverse().forEach((weekData:any, weekNo:number) => {
      //console.log(weekData[0].date);
      this.lineChartData.labels?.push(
        weekNo+1
      );
        
      var units = 0;
      var weekTotals = this.userDrinkService.geterateWeekTotals(weekData);
      this.lineChartData.datasets[0].data.push(weekTotals.totalUnits);
    });
  }


}
